import styled from 'styled-components';
import { Row, Col, Select } from 'antd';

import useI18n from '../../common/hooks/useI18n';
import { FlatOrderBy } from '../../common/model/enums/flatOrderBy.enum';

type Props = {
  resultsCount: number;
  orderBy: string;
  onOrderByChange: (orderBy: string) => void;
  className?: string;
};

const StyledRow = styled(Row)`
  font-size: 14px;
  line-height: 18px;
  @media ${(props) => props.theme.breakpoints.xs} {
    font-size: 12px;
    line-height: 16px;
  }

  .ant-select {
    font-size: 14px;
    line-height: 18px;
    @media ${(props) => props.theme.breakpoints.xs} {
      font-size: 12px;
      line-height: 16px;
    }
  }
`;

const ResultsTopSection = ({
  resultsCount,
  orderBy,
  onOrderByChange,
  className,
}: Props): JSX.Element => {
  const i18n = useI18n();
  return (
    <div className={className}>
      <StyledRow align="middle" justify="space-between">
        <Col style={{ maxWidth: '66%' }}>
          <span>
            {resultsCount === 1
              ? i18n.t('search.subtitle.singular', {
                  resultsCount,
                })
              : i18n.t('search.subtitle.plural', {
                  resultsCount,
                })}
          </span>
        </Col>

        <Col>
          <Select
            value={orderBy}
            bordered={false}
            dropdownMatchSelectWidth={false}
            onChange={(value) => onOrderByChange(value)}
          >
            <Select.Option value={FlatOrderBy.PRICE_ASC}>
              {i18n.t(`enums.flatOrderBy.${FlatOrderBy.PRICE_ASC}`)}
            </Select.Option>
            <Select.Option value={FlatOrderBy.PRICE_DESC}>
              {i18n.t(`enums.flatOrderBy.${FlatOrderBy.PRICE_DESC}`)}
            </Select.Option>
          </Select>
        </Col>
      </StyledRow>
    </div>
  );
};

export default styled(ResultsTopSection)`
  margin-bottom: 2rem;
`;
